import React from 'react';
import { func, string, shape, arrayOf } from 'prop-types';

import { AvailabilityButton } from '../buttons/availability-button';

import './availability-list.scss';

export const AvailabilityList = ({
  title,
  store,
  availableHours,
  selectedButton,
  setSelectedButton
}) => {

  return (
    <div className="availability-list">
      <div className="availability-title">{title}</div>
      <div className="availability-options">
        {availableHours.map((times, index) => (
          <AvailabilityButton
            key={index}
            startDate={times.start}
            endDate={times.end}
            store={store}
            identifier={`${store.storeId}-${index}`}
            setSelectedButton={setSelectedButton}
            selectedButton={selectedButton}
          />
        ))}
      </div>
    </div>
  );

};

AvailabilityList.propTypes = {
  title: string.isRequired,
  store: shape({}).isRequired,
  availableHours: arrayOf(shape({})).isRequired,
  selectedButton: string.isRequired,
  setSelectedButton: func.isRequired
};